import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
  faCog,
} from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/** Console output panel matching the in-app bottom dock */
const ConsolePanel = ({ title, context, icon, lines, status = 'Done' }: {
  title: string;
  context?: string;
  icon?: IconDefinition;
  lines: { time: string; type: 'info' | 'success' | 'warning'; source?: string; message: string }[];
  status?: string;
}) => (
  <div className="rounded-lg border border-white/[0.06] overflow-hidden shadow-lg shadow-black/10 font-mono text-[12px]" style={{ background: '#1e1e2e' }}>
    <div className="flex items-center justify-between px-3 py-1.5 border-b border-gray-700 bg-gray-800/50">
      <div className="flex items-center gap-2 text-xs">
        <FontAwesomeIcon icon={icon || faCog} className="w-3 h-3 text-gray-400" />
        <span className="text-gray-300">{title}</span>
        {context && (
          <>
            <span className="text-gray-500">&middot;</span>
            <span className="text-gray-400">{context}</span>
          </>
        )}
        <span className={`px-1.5 py-0.5 rounded text-[10px] uppercase tracking-wide ${status === 'Done' ? 'bg-gray-600/30 text-gray-400' :
          status === 'Running' ? 'bg-blue-500/20 text-blue-400' :
            'bg-gray-600/30 text-gray-400'
          }`}>{status}</span>
      </div>
    </div>
    <div className="p-2 font-mono text-xs">
      {lines.map((l, i) => (
        <div key={i} className="flex items-start gap-2 py-0.5 hover:bg-gray-700/30">
          <span className="text-gray-500 select-none">[{l.time}]</span>
          <FontAwesomeIcon
            icon={l.type === 'success' ? faCheckCircle : l.type === 'warning' ? faExclamationTriangle : faInfoCircle}
            className={`w-3 h-3 mt-0.5 ${l.type === 'success' ? 'text-green-400' : l.type === 'warning' ? 'text-amber-400' : 'text-cyan-400'}`}
          />
          {l.source && <span className="text-gray-500">[{l.source}]</span>}
          <span className={`flex-1 ${l.type === 'success' ? 'text-green-300' : l.type === 'warning' ? 'text-amber-300' : 'text-cyan-300'}`}>
            {l.message}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default ConsolePanel;
